export const locale = {
  lang: 'fr-CA',
  data: {
    CHAT: {
      TITLE: 'Chat',
      CHATS: 'Conversations',
      SEARCH: 'Rechercher',
      NO_RESULTS: 'Aucun résultat…',
      NEW_CONVERSATION: 'Nouvelle conversation',
      SELECT_CONVERSATION: 'Choisis une conversation pour commencer',
      TYPE_MESSAGE: 'Écrire un message…',
      LOCKED: 'Cette conversation est verrouillée',
      DELETED_MESSAGE: 'Message supprimé',
      ATTACHMENT: 'Pièce jointe',
      EDITED: '(modifié)',
      SEND_FAILED: "Échec de l'envoi",
      RETRY: 'Réessayer',
      REPLY: 'Répondre',
      EDIT: 'Modifier',
      DELETE: 'Supprimer',
      PIN: 'Épingler',
      UNPIN: 'Désépingler',
      MUTE: 'Désactiver les notifications',
      UNMUTE: 'Réactiver les notifications',
      DIRECT: 'Message direct',
      GROUP: 'Groupe',
      GROUP_NAME: 'Nom du groupe',
      SELECT_USERS: 'Choisir des collègues',
      VIEW_CONVERSATIONS: 'Voir les conversations',
      SELECT_ALL: 'Tout sélectionner',
      DESELECT_ALL: 'Tout désélectionner',
      CREATE: 'Créer',
      CANCEL: 'Annuler',
      EDITING: 'Modification du message',
      REACT: 'Réagir',
      COPY: 'Copier le texte',
      COPIED: 'Texte copié',
      AND_N_OTHERS: 'et {{count}} autres',
      UPLOAD_TOO_MANY: 'Maximum 5 fichiers par message',
      UPLOAD_TOO_BIG: '« {{name}} » dépasse 10 Mo',
      UPLOAD_BAD_TYPE: 'Type de fichier non accepté : « {{name}} »',
      DROP_HERE: 'Déposer les fichiers ici',
      TYPING_ONE: '{{name}} écrit…',
      TYPING_TWO: '{{a}} et {{b}} écrivent…',
      TYPING_MANY: 'Plusieurs personnes écrivent…',
      PINNED_TITLE: 'Messages épinglés',
      NO_PINNED: 'Aucun message épinglé',
      NEW_MESSAGES: 'Nouveaux messages',
      DELETE_MESSAGE_CONFIRM: 'Supprimer ce message ?',
      ONLINE: 'En ligne',
      START_HINT: 'Sélectionnez un collègue pour démarrer une conversation',
      MENTION_FALLBACK: 'Utilisateur',
      MENTION_ALL_HINT: 'Notifier tous les participants',
      MENTIONED_YOU: 'Vous avez été mentionné',
      SEARCH_RESULTS: 'Résultats dans les messages',
      IN_THIS_CONVERSATION: 'Dans cette conversation',
      SYSTEM: {
        conversation_created: 'Conversation créée',
        conversation_renamed: 'La conversation a été renommée',
        participant_joined: 'Un participant a rejoint la conversation',
        participant_left: 'Un participant a quitté la conversation',
        participants_added: 'Des participants ont été ajoutés',
        participant_removed: 'Un participant a été retiré',
      },
    },
  },
};
